import React, { useEffect, useState } from "react";
import { api } from "services";
import { useNavigate } from "react-router-dom";

const Index = () => {
  const [managers, setManagers] = useState([]);
  var navigate = useNavigate();

  useEffect(() => {
    api.accountManagers().then((res) => {
      setManagers(res);
    });
  }, []);

  const back = () => {
    navigate(-1);
  }

  const ManagerView = ({ item }) => (
    <div className="p-2">
      <div className="card border-app" >
        <div className="card-body">
          <div className="card-title">
            <b className="text-secondary">{item.get("name")}</b>
          </div>
          <div className="card-subtitle mb-2 text-app opacity-75">
            {item.get("location")} - {item.get("state")}
          </div>
          <div className="card-text">{item.get("discription")}</div>
          <div>
            <div className="m-2 cursor-pointer">
              <a
                href={`https://wa.me/${item.get("whatsapp")}`}
                target="_blank"
                className="text-decoration-none text-dark"
              >
                <i className="bi bi-telephone m-2"></i>
                {item.get("phone")}
              </a>
            </div>
            <div className="m-2 ">
              <a
                href={`https://wa.me/${item.get("whatsapp")}`}
                target="_blank"
                className="text-decoration-none text-dark"
              >
                <i className="bi bi-whatsapp m-2"></i>
                {item.get("whatsapp")}
              </a>
            </div>
          </div>
          <div>
            <div className="m-2">
              <a
                href={`mailto:${item.get("email")}`}
                target="_blank"
                className="text-decoration-none text-dark"
              >
                <i className="bi bi-envelope m-2"></i>{" "}
                {item.get("email")}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )

  return (
    <div className="container">
      <div className="row mt-3 mt-md-5">
        <div className="col-2 col-md-1">
          <a role="button" className="btn btn-app" onClick={back} title="Back">
            <i className="bi bi-arrow-left"></i>
          </a>
        </div>
        <div className="col-10 col-md-11">
          <h2 className="">Account Managers</h2>
        </div>
      </div>

      <hr />
      <div className="mt-3 mt-md-5 row p-2 row-cols-1 row-cols-md-2 row-cols-lg-3">
        {managers && managers.map((manager, i) => <ManagerView item={manager} />)}
      </div>
    </div>
  );
};

export default Index;
